export interface GossipItem {
  id: string;
  category: string;
  categoryKey: string;
  title: string;
  summary: string;
  time: string;
  heat: string;
  views: number;
  likes: number;
  comments: number;
  tag: string;
  author: string;
  read: string;
  cover: string;
  body: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export const categories = [
  { key: "all", name: "今日瓜田" },
  { key: "xing", name: "明星动态" },
  { key: "zongyi", name: "影视综艺" },
  { key: "bagua", name: "圈内八卦" },
  { key: "hongtan", name: "红毯现场" },
];

export const hotRank = [
  { rank: 1, title: "林晚棠新剧杀青照流出，素颜状态被讨论上热搜", heat: "986万", up: true },
  { rank: 2, title: "综艺《半熟露营》爆冷出圈，嘉宾人设反转引热议", heat: "812万", up: true },
  { rank: 3, title: "沈之衡巡演歌单疑似暗藏分手歌词，粉丝深夜破防", heat: "677万", up: true },
  { rank: 4, title: "某剧组深夜食堂视频曝光，全员形象意外圈粉", heat: "523万", down: true },
  { rank: 5, title: "许嘉宁机场造型被偶遇，同款卫衣三小时内卖断货", heat: "441万", down: true },
  { rank: 6, title: "红毯主持人现场机智救场，被网友封为名场面", heat: "390万", up: true },
  { rank: 7, title: "顾云舟生日直播读粉丝来信，读到一半眼眶红了", heat: "328万", up: true },
];

export const gossipItems: GossipItem[] = [
  {
    id: "item-01",
    category: "明星动态",
    categoryKey: "xing",
    title: "林晚棠新剧杀青照流出，素颜状态空降热搜",
    summary: "收工照里连妆都没卸干净的松弛感，反而比精修图更圈粉。片场细节一扒，网友直呼这波敬业是真的。",
    time: "今天 14:20",
    heat: "986万",
    views: 986000,
    likes: 56200,
    comments: 8314,
    tag: "实锤",
    author: "瓜田老李",
    read: "4分钟",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20backstage%20of%20a%20film%20set%20at%20dusk%2C%20warm%20amber%20studio%20lights%20reflecting%20on%20the%20floor%2C%20movie%20clapperboard%20and%20camera%20equipment%20silhouette%2C%20moody%20editorial%20photography%2C%20soft%20bokeh%2C%20film%20noir%20atmosphere&width=720&height=460&seq=gossip-cover-01&orientation=landscape",
    body: [
      "昨晚十点半，一张没有加任何滤镜的收工照在社交平台悄悄流传。照片里林晚棠靠在片场椅背上，头发随意扎起，连戏服都没来得及换，眼睛却亮得惊人。评论区瞬间炸开：『这状态居然是真素颜？』",
      "随后有知情工作人员透露，为了赶这场大夜戏，她已经连续三天每天只睡四小时，收工后还坚持把对手戏的回放逐条看过才肯走。剧组的灯光老师感慨：『现在的年轻演员，肯这么抠细节的不多了。』",
      "真正把讨论推上热搜的，是网友扒出的一段录音——她在候场时跟对手演员对戏，把一句台词改了三版，还逐字解释人物动机。有剧评人转评：『这不是会演戏，这是懂角色。』",
      "截至发稿，这条话题阅读量已接近千万。我们也在持续跟进片方的正式回应，若后续有物料更新，将第一时间同步到瓜田。",
    ],
  },
  {
    id: "item-02",
    category: "影视综艺",
    categoryKey: "zongyi",
    title: "综艺《半熟露营》爆冷出圈，嘉宾人设集体反转",
    summary: "没有剧本感的露营慢综，靠真实反应杀出重围。上一秒还在互怼，下一秒就开始给对方煮面，观众看笑了。",
    time: "今天 12:05",
    heat: "812万",
    views: 812000,
    likes: 44300,
    comments: 6721,
    tag: "热评",
    author: "夜宵磕瓜",
    read: "3分钟",
    cover: "https://readdy.ai/api/search-image?query=tents%20glowing%20under%20the%20stars%20in%20a%20mountain%20camping%20field%20at%20night%2C%20bonfire%20with%20warm%20orange%20flames%2C%20campfire%20stories%2C%20cozy%20outdoor%20reality%20show%20scene%2C%20cinematic%20photography&width=720&height=460&seq=gossip-cover-02&orientation=landscape",
    body: [
      "上周末开播的《半熟露营》，几乎没有任何宣发预算，却凭口碑一路逆袭到热门综艺榜前列。节目组给出的设定很简单：几位不算熟的艺人，在深山里同吃同住三天两夜。",
      "第一期最大的惊喜，是『人设崩塌』。镜头前惯常高冷的孟清野，搭帐篷时手忙脚乱，最后被同组嘉宾按着头教了半小时；而看起来柔柔弱弱的程若诗，一个人扛了两袋木柴还面不改色。反差感直接拉满。",
      "弹幕里观众最买账的是真实感：凌晨三点有人饿醒，第一反应是摸黑去给全组煮了泡面，还没忘放个溏心蛋。导演组在花絮里写：『我们没给他们剧本，因为最好的剧本是真心。』",
      "目前节目第二期预告已上线，据说有人背着大家偷偷准备生日惊喜。想持续蹲这档下饭综艺的瓜，记得把爆料网加进追更列表。",
    ],
  },
  {
    id: "item-03",
    category: "圈内八卦",
    categoryKey: "bagua",
    title: "沈之衡巡演歌单疑藏分手讯号，粉丝集体破防",
    summary: "压轴歌从《我们的夏天》换成《一个人的四季》，同一场巡演临开场换曲，联排花絮里的眼神也值得细品。",
    time: "今天 10:40",
    heat: "677万",
    views: 677000,
    likes: 38800,
    comments: 9203,
    tag: "传闻",
    author: "一颗茼蒿",
    read: "3分钟",
    cover: "https://readdy.ai/api/search-image?query=singer%20silhouette%20on%20stage%20with%20single%20spotlight%20and%20blue%20purple%20haze%2C%20empty%20concert%20hall%20during%20soundcheck%2C%20emotional%20atmosphere%2C%20cinematic%20concert%20photography&width=720&height=460&seq=gossip-cover-03&orientation=landscape",
    body: [
      "昨晚的巡演开场前十五分钟，主办方临时更新了歌单：原定压轴的《我们的夏天》被换成了《一个人的四季》。眼尖的站姐第一时间截图发博，话题在十分钟内冲上热搜。",
      "粉丝顺着线索往下扒，发现这两周沈之衡的社交账号就透着『怪』——不晒合照了，动态里的配文从『我们』变成了『我』，连头像都换成了一张空无一人的海边。",
      "更让人浮想联翩的是联排流出的花絮：唱到那句『终于学会，一个人入睡』时，他明显在台上站定了两秒才继续。弹幕里有人刷『唱到这句眼睛红了』，也有人冷静提醒『别过度解读，就是歌词走心而已』。",
      "截至现在，工作室尚未就换曲原因作出说明。无论是误会还是真讯号，瓜田都会陪大家一起盯着，一有回应立刻跟进。",
    ],
  },
  {
    id: "item-04",
    category: "明星动态",
    categoryKey: "xing",
    title: "许嘉宁机场偶遇被拍，同款卫衣三小时卖断货",
    summary: "一件普通的连帽卫衣被她穿出松弛感，带货能力依然能打。机场路透里的小动作也被粉丝逮个正着。",
    time: "昨天 22:18",
    heat: "523万",
    views: 523000,
    likes: 29100,
    comments: 4110,
    tag: "热评",
    author: "蹲瓜的小满",
    read: "2分钟",
    cover: "https://readdy.ai/api/search-image?query=modern%20airport%20terminal%20with%20large%20windows%2C%20young%20traveler%20silhouette%20carrying%20a%20hoodie%20bag%2C%20soft%20morning%20light%20streaming%20in%2C%20fashion%20street%20style%20editorial%20photography&width=720&height=460&seq=gossip-cover-04&orientation=landscape",
    body: [
      "早上七点不到，许嘉宁的身影出现在机场出发层。没有助理开道，自己拖着箱子，头上压着顶渔夫帽，低头回消息，愣是没被第一时间认出来。",
      "直到有人拍到她卫衣背后那串手写体字母发上社交平台，认出这是某个小众设计师品牌——结果你猜怎么着？三小时内，该款全线断货。品牌方连夜发声明致谢，还开玩笑说正在加急补单。",
      "路透里还有个小细节：过安检时她特意回头冲镜头挥了下手，动作自然得像邻家姐姐。这种不刻意营业的松弛，反而是她圈粉的关键。",
      "评论区清一色在求完整穿搭清单。我们也把几位时尚博主的解析整理成了专题，蹲同款的朋友可以去瓜田的『明星穿搭』栏目翻翻。",
    ],
  },
  {
    id: "item-05",
    category: "红毯现场",
    categoryKey: "hongtan",
    title: "红毯主持现场机智救场，被网友封为年度名场面",
    summary: "某嘉宾话筒突然失声，主持人一句「这麦都在抢着替你说话」四两拨千斤，台下掌声雷动。",
    time: "昨天 19:30",
    heat: "441万",
    views: 441000,
    likes: 51200,
    comments: 3640,
    tag: "实锤",
    author: "现场小瓜农",
    read: "2分钟",
    cover: "https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20event%20at%20night%2C%20rows%20of%20photographers%20flashes%2C%20spotlight%20and%20marquee%20lights%2C%20elegant%20crowd%20silhouettes%2C%20festive%20and%20lively%20award%20ceremony%20atmosphere&width=720&height=460&seq=gossip-cover-05&orientation=landscape",
    body: [
      "每年红毯总会出几个『考验情商』的瞬间，今年这位主持人的临场反应直接封神。当某位嘉宾拿起话筒正要开口，麦却当场失声，场面一度要冷。",
      "主持人不慌不忙递上备用麦，笑着补了一句：『你看，连话筒都急着替你先说两句，可见观众有多期待你开口。』台下先是安静了一瞬，随即爆发出掌声和会心的笑声，尴尬被轻松化解。",
      "这段视频被剪出来单循环播放，弹幕齐刷刷飘过『主持界的教科书』『这才是真正的救场』。事后有工作人员透露，其实备用麦是提前备好的，但临场那句接话，是真的没彩排。",
      "娱乐圈最不缺聚光灯，缺的是这种把专业藏进细节里的人。这场红毯还有哪些被镜头一闪而过的名场面？可以到瓜田合集里继续补课。",
    ],
  },
  {
    id: "item-06",
    category: "圈内八卦",
    categoryKey: "bagua",
    title: "顾云舟生日直播读粉丝来信，读到一半眼眶泛红",
    summary: "本意是『读几封就走』，结果一口气读了半小时。信里那句『谢谢你陪我们长大』，让他半天没接上话。",
    time: "昨天 15:00",
    heat: "390万",
    views: 390000,
    likes: 47800,
    comments: 5220,
    tag: "温暖",
    author: "一颗茼蒿",
    read: "3分钟",
    cover: "https://readdy.ai/api/search-image?query=cozy%20home%20live%20studio%20at%20night%20with%20warm%20string%20lights%20and%20a%20stack%20of%20paper%20letters%20on%20a%20desk%2C%20soft%20warm%20glow%2C%20intimate%20personal%20moment%2C%20cinematic%20editorial%20photo&width=720&height=460&seq=gossip-cover-06&orientation=landscape",
    body: [
      "昨天晚上顾云舟的生日直播，开场就说『简单跟大家聊聊天就下』。结果助理搬来一个纸箱，里面是粉丝寄来的厚厚一沓手写信。他挑了几封拆开，本想快速念完应付过去。",
      "念到一封来自刚参加完中考女孩的信时，他顿住了。信上说：『谢谢你在我最难的那年，用你的歌陪我做题，现在我要去上高中啦。』他垂着眼睛读了两遍，忽然笑了一下，声音有点哑：『这封信……我留着。』",
      "原本定好的一小时直播，硬是超时聊到快两小时。他没读完全部信，却认真地一封一封摸了封皮，说要带回家慢慢看。下播前他对着镜头说了句：『能被你们喜欢，是我这几年最好的事。』",
      "没有炒作，没有卖惨，只是几个普通人隔着屏幕认真交换了一次真心。这大概就是大家愿意一直陪着他的原因吧。",
    ],
  },
  {
    id: "item-07",
    category: "影视综艺",
    categoryKey: "zongyi",
    title: "某剧组深夜食堂被拍，全员形象意外大圈粉",
    summary: "收工后的剧组不聊戏只抢鸡腿，导演蹲在角落嗦面，女主角素面朝天排队打饭，这画面谁看了不说一句真实。",
    time: "昨天 09:15",
    heat: "328万",
    views: 328000,
    likes: 36100,
    comments: 2910,
    tag: "热评",
    author: "夜宵磕瓜",
    read: "3分钟",
    cover: "https://readdy.ai/api/search-image?query=night%20time%20film%20crew%20dinner%20canteen%20with%20steaming%20hot%20food%20and%20lantern%20light%2C%20people%20sitting%20around%20long%20tables%20eating%20noodles%2C%20warm%20casual%20behind%20the%20scenes%2C%20documentary%20style%20photography&width=720&height=460&seq=gossip-cover-07&orientation=landscape",
    body: [
      "收工后的一张偷拍，让整个剧组的形象一夜之间立体了起来。照片里没有精修，只有一群累得东倒西歪的人，围着热气腾腾的宵夜桌埋头干饭。",
      "最出圈的细节：导演捧着一次性碗蹲在墙角嗦面，跟摄像大哥聊明天的机位；女主角顶着一脸没卸干净的妆，素面朝天站在打饭队伍里，被拍到也不躲，还回头比了个『嘘』。",
      "网友的评论很统一：『这不就是我下班的样子吗』『明星滤镜碎了，但更可爱了』。有现场群演补充，其实这个组从开机到现在，全组上下没吃过一次单独的小灶，都是同一口锅里吃饭。",
      "深夜食堂的烟火气，比任何宣传物料都更有说服力。这组图已经在社交平台刷屏，我们也会持续关注这部剧后续的物料节奏。",
    ],
  },
  {
    id: "item-08",
    category: "明星动态",
    categoryKey: "xing",
    title: "宋既白结束海外行程回国，怀里抱着一只猫",
    summary: "机场出口那只奶猫抢尽风头，助理手上拿着航空箱却空着，网友笑称：这是顺道『领养』了个家人回来。",
    time: "昨天 08:02",
    heat: "287万",
    views: 287000,
    likes: 27500,
    comments: 2410,
    tag: "传闻",
    author: "瓜田老李",
    read: "2分钟",
    cover: "https://readdy.ai/api/search-image?query=airport%20arrival%20hall%20evening%2C%20young%20man%20gently%20holding%20a%20small%20white%20kitten%20in%20his%20arms%2C%20soft%20warm%20terminal%20lighting%2C%20heartwarming%20candid%20moment%2C%20documentary%20style%20photo&width=720&height=460&seq=gossip-cover-08&orientation=landscape",
    body: [
      "凌晨两点落地的宋既白，没走贵宾通道，而是低调从普通出口出来。但怀里那个不安分的小东西出卖了他——一只奶声奶气的小白猫，正扒着他的卫衣领子探头探脑。",
      "有粉丝认出，他在海外那几天的日常 vlog 里，就反复出现一只黏人的流浪猫。看来不是摆拍，是真的『处出感情了』。助理手里拖着空的航空箱，画面莫名喜感，网友调侃：『箱子带了，猫没装进去，人倒是被猫收编了。』",
      "宋既白在个人账号发了一条动态，配文只有六个字：『带回来了，放心。』并晒出猫的一整套体检单和疫苗本，显然是走正规手续带回，考虑得很周全。",
      "评论区从催更新剧到问猫叫什么名字，话题走向清奇。我们也好奇，这只初来乍到的『家人』，未来会不会出现在他的镜头里。蹲一个后续。",
    ],
  },
  {
    id: "item-09",
    category: "圈内八卦",
    categoryKey: "bagua",
    title: "综艺补录现场被曝「剪辑魔改」，当事人亲自下场澄清",
    summary: "一句闲聊被剪成「吐槽前辈」，当事人连夜发文还原真相，节目组随后放出完整原片道歉。",
    time: "前天 21:40",
    heat: "262万",
    views: 262000,
    likes: 19800,
    comments: 4560,
    tag: "实锤",
    author: "现场小瓜农",
    read: "3分钟",
    cover: "https://readdy.ai/api/search-image?query=editing%20suite%20with%20multiple%20monitors%20showing%20video%20timelines%2C%20dim%20room%20glowing%20screens%2C%20post%20production%20control%20room%20at%20night%2C%20cinematic%20tech%20photography&width=720&height=460&seq=gossip-cover-09&orientation=landscape",
    body: [
      "前几天一档综艺预告片里，程若诗一句玩笑被剪得像是『吐槽某位老前辈的演技』，预告一出立刻引发争议，甚至有观众开始站队。",
      "当天深夜，程若诗本人发了一条长文，语气平静但字字清晰：她还原了当时的完整语境——那句其实是两人在片场互相鼓励的玩笑，还被前辈笑着接了一句。她强调：『前辈是我很敬重的人，绝无冒犯之意。』",
      "舆论发酵不到半天，节目组正式道歉，放出未剪辑原片，承认是剪辑节奏问题造成的误会，并承诺后续所有正片上线前会进行三方复核。网友的态度也迅速从『声讨』转向『节目组这波处理还算体面』。",
      "这件事也给整个行业提了个醒：剪辑的边界，不该建立在牺牲真实性之上。我们把来龙去脉整理成了时间线，吃瓜的你可以点开对比原片，自己判断。",
    ],
  },
  {
    id: "item-10",
    category: "影视综艺",
    categoryKey: "zongyi",
    title: "新剧《长街巷尾》首播口碑分化，一场戏成全剧名场面",
    summary: "服化道被夸「质感在线」，节奏却被嫌慢热。直到第十集那场雨戏，弹幕风向集体反转。",
    time: "前天 18:00",
    heat: "231万",
    views: 231000,
    likes: 22300,
    comments: 1870,
    tag: "热评",
    author: "蹲瓜的小满",
    read: "3分钟",
    cover: "https://readdy.ai/api/search-image?query=rainy%20old%20street%20in%20a%20chinese%20period%20drama%20at%20night%2C%20warm%20lantern%20glow%20reflecting%20on%20wet%20stone%20pavement%2C%20two%20figures%20standing%20under%20an%20umbrella%2C%20atmospheric%20cinematic%20photography&width=720&height=460&seq=gossip-cover-10&orientation=landscape",
    body: [
      "开播首周，《长街巷尾》的口碑意外地两极。夸的人说它慢得像在绣花，一针一线都是细节；嫌的人说前几集铺垫太长，看得人着急。两边谁也说服不了谁。",
      "转折发生在第十集。男女主在旧街巷口那场雨戏，没有任何台词，全靠眼神和一把伞演完了半集。镜头扫过墙角被雨打湿的旧告示、屋檐滴落的檐水，慢节奏在这一刻突然变成了恰到好处的留白。",
      "弹幕从『能不能快进』刷成『求这段别停』，话题当晚冲上讨论榜前三。有剧评人写道：『前九集的「慢」，原来都是在给这场雨攒情绪。』",
      "目前全剧已更新过半，据说后半段还有几场重头戏在等着。是神剧还是烂尾，我们边追边给你划重点，别忘了蹲更新。",
    ],
  },
];

export const faqItems: FaqItem[] = [
  {
    q: "爆料网上的「瓜」都是从哪里来的？",
    a: "爆料网的资讯主要来自公开社交动态、正规媒体通稿、节目与剧组官方物料，以及经多位目击者交叉核实的现场报料。平台设有「来源标注」机制，标为「实锤」的内容均附带可查证依据，标为「传闻」的内容会明确提示尚未得到官方回应。",
  },
  {
    q: "标着「实锤」和「传闻」有什么区别？",
    a: "「实锤」表示该事件有官方声明、现场视频或当事人发文等直接证据支撑；「传闻」则来自单一路透或匿名信源，真实性还在核实中。吃瓜时请先看角标，理性看待，避免误传。",
  },
  {
    q: "发现报道与实际不符，如何向你们反馈？",
    a: "若您发现内容有误或希望纠正，可通过页面底部的联系方式或联系邮箱 service@baoliao.net 提交依据。经核实确属不实的报道，我们会按流程删除或更正，并在原文位置作出说明。",
  },
  {
    q: "如何第一时间收到新瓜更新的提醒？",
    a: "在页脚的快讯订阅栏留下您的常用邮箱，最新热料和热榜更新会第一时间推送到您的邮箱。我们只发送吃瓜快讯，不会用您的信息做任何其他用途，也随时可以一键退订。",
  },
];